import {Pipe, PipeTransform, inject} from '@angular/core';
import {LanguageService} from "../services/language.service";

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  private languageService: LanguageService = inject(LanguageService);


  public transform(value: string): string {
    return this.languageService.getTranslationByKey(value);
  }

}
